/**
 * FAQ page: build "Jump to section" links from every h2 in the main content column.
 * Uses a preceding #faq-* anchor when present; otherwise assigns an id on the heading.
 */
function slugifyHeadingId(text, seen, idCounter) {
  let id = text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .substring(0, 50);

  let uniqueId = id || `faq-heading-${idCounter}`;
  while (seen.has(uniqueId)) {
    idCounter++;
    uniqueId = `${id || 'faq-heading'}-${idCounter}`;
  }

  return { id: uniqueId, idCounter };
}

function getFaqJumpTarget(heading, seen, idCounterRef) {
  const block = heading.closest('.shopify-block');
  const prevBlock = block?.previousElementSibling;
  const anchor = prevBlock?.querySelector('[id^="faq-"]');

  if (anchor?.id) {
    return { id: anchor.id, scrollElement: anchor };
  }

  let id = heading.id;
  if (!id) {
    const text = heading.textContent.replace(/\s+/g, ' ').trim();
    const slug = slugifyHeadingId(text, seen, idCounterRef.value);
    id = slug.id;
    idCounterRef.value = slug.idCounter;
    heading.id = id;
  }

  return { id, scrollElement: heading };
}

function buildFaqJumpNav() {
  const list = document.querySelector('[data-faq-jump-nav-list]');
  if (!list) return;

  const section = list.closest('.shopify-section');
  if (!section) return;

  const sidebar = section.querySelector('.faq-page-sidebar');
  const headings = [...section.querySelectorAll('h2')].filter(
    (heading) => !sidebar?.contains(heading)
  );

  list.innerHTML = '';

  const tocPanel = list.closest('.faq-page-sidebar__panel--toc');
  if (headings.length === 0) {
    if (tocPanel) tocPanel.style.display = 'none';
    return;
  }
  if (tocPanel) tocPanel.style.display = '';

  const seen = new Set();
  const idCounterRef = { value: 0 };

  for (const heading of headings) {
    const { id, scrollElement } = getFaqJumpTarget(heading, seen, idCounterRef);
    if (!id || seen.has(id)) continue;
    seen.add(id);

    scrollElement.style.scrollMarginTop = 'var(--sticky-header-offset, 6rem)';

    const label = heading.textContent.replace(/\s+/g, ' ').trim();
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = label;
    li.appendChild(a);
    list.appendChild(li);
  }
}

buildFaqJumpNav();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target?.querySelector?.('[data-faq-jump-nav-list]')) {
    buildFaqJumpNav();
  }
});
